import React from 'react';
import { Form } from 'react-bootstrap';
import { FormSelect, FormNumber, Selectize } from '~/components/FormControl';
import { COMPARED_OPTIONS } from '~/config/constants';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';

function ConditionPassiveDetail() {
    const { cardMetaData } = useFormTab();
    const { effects, conditions, prompts } = cardMetaData;

    return (
        <>
            {JSON.stringify(cardMetaData) !== '{}' ? (
                <Form.Row>
                    <Selectize
                        sm="3"
                        name="conditionPassiveDetail.conditionPassiveEffects"
                        options={[...effects, ...conditions, ...prompts] || []}
                        tooltip="Passive effects that activates when player has the card. Ex: Alacrity"
                    />
                    <FormSelect
                        name="conditionPassiveDetail.conditionPassiveOption"
                        options={COMPARED_OPTIONS}
                        sm="3"
                        tooltip="If the passive condition checks for DV, this will select the comparative type."
                    />
                    <FormNumber
                        name="conditionPassiveDetail.conditionPassiveValue"
                        sm="3"
                        tooltip="If the passive condition checks for DV, this will check player's DV against this value."
                    />
                    <FormNumber
                        name="conditionPassiveDetail.conditionPassiveModifiedValue"
                        sm="3"
                        tooltip="How much DV will be changed after the first condition effect ends?"
                    />
                </Form.Row>
            ) : (
                ''
            )}
        </>
    );
}

export default ConditionPassiveDetail;
